import React from "react";
import SEO from "../components/SEO";
import "./TermsandConditions.css";

const TermsandConditions = () => {
  return (
    <div className="terms-container">
      <SEO
        title="Terms & Conditions — D Base Solutions Pvt Ltd"
        description="Terms of Service and Conditions of Use for D Base Solutions Pvt Ltd applications, platforms, and services."
        keywords="D Base Solutions terms and conditions, DBS terms of service, legal terms"
        canonical="https://dbasesolutions.in/terms-and-conditions"
        ogImage="/og-image.png"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Terms & Conditions", url: "/terms-and-conditions" }
        ]}
      />
      <div className="terms-card">
        <h1>Terms and Conditions</h1>


        <h2>1. Acceptance of Terms</h2>
        <p>
          By downloading, installing, accessing, or using the{" "}
          <strong>DBS OFFICE</strong> mobile application (the "App"), you agree
          to be bound by these Terms and Conditions ("Terms"). If you do not
          agree to these Terms, you must not access or use the App. The App is
          provided for the exclusive use of employees and authorized personnel
          of <strong>DBase Solutions Pvt. Ltd</strong>.
        </p>

        <h2>2. Intended Use and Eligibility</h2>
        <p>
          The App is an internal enterprise resource planning and human
          resources management tool. You may only use the App if you are a
          current employee, contractor, or authorized representative of the
          Company. Your access to the App is contingent upon your continued
          employment or authorization by the Company.
        </p>

        <h2>3. User Accounts and Security</h2>

        <h3>Account Credentials</h3>
        <p>
          You are responsible for maintaining the confidentiality of your login
          credentials (username, password, etc.).
        </p>

        <h3>Account Activity</h3>
        <p>
          You are responsible for all activities that occur under your account.
          You agree to notify your administrator immediately if you suspect any
          unauthorized use of your account.
        </p>

        <h3>Accuracy of Information</h3>
        <p>
          You agree to provide and maintain accurate, current, and complete
          information regarding your profile, work reports, leave requests, and
          all other submissions made through the App.
        </p>

        <h2>4. App Features and Permissions</h2>

        <p>
          By using specific features of the App, you consent to the collection
          and use of associated data as outlined in our Privacy Policy:
        </p>

        <ul>
          <li>
            <strong>AI Attendance (Biometrics):</strong> You consent to the
            capture, processing, and temporary storage of your facial image for
            identity verification and attendance logging.
          </li>

          <li>
            <strong>Location Services:</strong> You consent to the tracking of
            your device's location to verify attendance and work-site presence.
          </li>

          <li>
            <strong>Camera and Storage:</strong> You consent to camera and
            storage access for uploading profile photos, scanning QR codes, and
            attaching documents.
          </li>
        </ul>

        <h2>5. Acceptable Use Policy</h2>

        <p>You agree not to use the App to:</p>

        <ul>
          <li>
            Submit false or fraudulent attendance records, work reports, or
            expense claims.
          </li>

          <li>
            Attempt to bypass, disable, or interfere with security features or
            location tracking mechanisms.
          </li>

          <li>
            Upload malicious software, offensive content, or material violating
            Company policy.
          </li>

          <li>Access information you are not authorized to view.</li>

          <li>
            Use the App for any purpose outside your employment or authorized
            engagement.
          </li>
        </ul>

        <h2>6. Intellectual Property</h2>

        <p>
          All software, content, features, functionality, and design elements
          of the App are the exclusive property of the Company or its licensors.
          You are granted a limited, non-exclusive, non-transferable,
          revocable license to use the App solely for work-related purposes.
        </p>

        <h2>7. Disclaimers and Limitation of Liability</h2>

        <ul>
          <li>
            <strong>As-Is:</strong> The App is provided on an "AS IS" and "AS
            AVAILABLE" basis.
          </li>

          <li>
            <strong>No Guarantee:</strong> We do not guarantee uninterrupted,
            error-free, or secure operation.
          </li>

          <li>
            <strong>Limitation of Liability:</strong> The Company shall not be
            liable for indirect, incidental, consequential, or punitive damages
            arising from the use of the App.
          </li>
        </ul>

        <h2>8. Termination and Suspension</h2>

        <p>
          The Company may suspend or terminate your access at any time without
          prior notice for:
        </p>

        <ul>
          <li>Breach of these Terms.</li>
          <li>Violation of Company policies.</li>
          <li>Termination of employment or contract.</li>
        </ul>

        <p>
          Upon termination, your right to use the App immediately ceases and
          you must uninstall the App from your personal devices.
        </p>

        <h2>9. Changes to the Terms</h2>

        <p>
          We may modify these Terms at any time. Significant updates will be
          communicated through the App or official Company communication
          channels. Continued use constitutes acceptance of revised Terms.
        </p>

        <h2>10. Governing Law</h2>

        <p>
          These Terms shall be governed by the laws of{" "}
          <strong>[Insert Jurisdiction / State / Country]</strong>.
        </p>

        <h2>11. Contact Information</h2>

        <p>
          For questions regarding these Terms, contact:
        </p>

        <div className="contact-box">
          <p>
            <strong>DBase Solutions Pvt. Ltd</strong>
          </p>
          <p>Email: hr@dbasesolutions.in</p>
          <p>Phone: +91 93943 22302</p>
        </div>
      </div>
    </div>
  );
};

export default TermsandConditions;